import axios, { AxiosResponse, AxiosError } from "axios";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getAuthToken } from '../../Utils/auth.ts';
let isUnauthorizedHandled = false;
let isServerErrorHandled = false;
const handleUnauthorized = () => {
  if (isUnauthorizedHandled) return;
  isUnauthorizedHandled = true;

  localStorage.clear();
  toast.error("Login Expired.");

  if ((window as any).ReactNativeWebView) {
    (window as any).ReactNativeWebView.postMessage('logout');
  }
};
const handleServerError = () => {
  if (isServerErrorHandled) return;
  isServerErrorHandled = true;
  toast.error("Server Error");
};

export const getVehicleRoute = (
    vehicle_id: any,
    from_date: any,
    to_date: any,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const headers = {
      Authorization: `Bearer ${getAuthToken()}`,
    };

    const formData = new FormData();
    formData.append('vehicle_id', vehicle_id);
    formData.append('from_date', from_date);
    formData.append('to_date', to_date);

    axios
      .post(
        `${global.api_url}/api/vehicle_route`,
        formData,
        { headers }
      )
      .then((response) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        console.log('Error caught:', error);

        if (error.response?.status === 400 ||error.response?.status === 404 ) {
          _errorCallBack(error.response.data);
        } 
        else if (error.response?.status === 401) {
            handleUnauthorized();
        } 
        else {
          handleServerError();
        }
      });
  };
  export const getCurrentLocation = (
    companies_id: any,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const headers = {
      Authorization: `Bearer ${getAuthToken()}`,
      "Content-Type": "application/json",
    };
    const requestBody = {
      companies_id: companies_id, 
    };
  
    axios
      .post(
        `${global.api_url}/api/current_location`,
        requestBody,
        {
          headers: headers,
        }
      )
      .then((response: AxiosResponse) => {
        if (response.status === 200 || response.status === 201) {
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        } else if (error.response?.status === 401) {
          handleUnauthorized();
        } else if (error.response?.status === 404) {
          _errorCallBack(error.response.data);
        } else {
          handleServerError();
        }
      });
  };
  export const getInstitutionVehicleMapping = (
    vehicle_id:number[] | any[],
    driver_id:any,
    per_page_records: any,
    page_number: any,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  
  const requestBody = vehicle_id && vehicle_id.length > 0 ? { vehicle_id: vehicle_id } : {};
    axios
      .get(`${global.stms_url}/institution_vehicles?page_number=${page_number}&per_page_records=${per_page_records}`, { params: { ...requestBody, driver_id: driver_id } })
      .then((response: AxiosResponse) => {
        if (response.status === 200 || response.status === 201) {
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400 || error.response?.status === 404) {
          _errorCallBack(error.response.data);
        } else if (error.response?.status === 401) {
          localStorage.clear();
        } else {
          toast.error("Server Error");
          _errorCallBack(error);
        }
      });
  };